export class CartDto {
  id?: string;
  userId?: string;
  entries: CartEntry[] = [];
  subtotal: number;
}

class CartEntry {
    productId: string;
    productName: string;
    quantity: number;
    price: number;
}